import { COMMUNITY_EXPLORE_LINK, MEDAL_PERIODS } from "./data/DiscordPageData";

export default function DiscordMedals() {
  return (
    <>
      {/* ── MEDALS ───────────────────────────────────────────────── */}
      <section className="dsc-section" id="medals">
        <div className="dsc-eyebrow">Achiever Medals</div>
        <h2 className="dsc-h2">
          Top the board, <span className="hi">earn the medal</span>
        </h2>
        <p className="dsc-section-sub dsc-wide">
          The Most active board on Explore settles every day, week and month.
          Whoever finishes first takes the Achiever medal, and the member with
          the most commits and the member with the most pull requests each take
          one too. Medals stack as <strong>×N</strong> every time you win, and
          every win pays quantum points.
        </p>

        <div className="dsc-medals">
          {MEDAL_PERIODS.map((m) => (
            <div key={m.period} className="dsc-medal">
              <div className="dsc-medal-period">{m.period}</div>
              <img
                src={m.image}
                alt={`${m.name} medal`}
                className="dsc-medal-img"
                loading="lazy"
              />
              <div className="dsc-medal-name">{m.name}</div>
              <div className="dsc-medal-pts">+{m.points} points</div>
              <p className="dsc-medal-how">{m.how}</p>
              <ul className="dsc-medal-extra">
                {m.extra.map((e) => (
                  <li key={e.name}>
                    <span>
                      {e.name}
                      <small>{e.how}</small>
                    </span>
                    <b>+{e.points}</b>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="dsc-note">
          Leader medals go to the best of a window's top ten. Medal points raise
          your total and your tier but are left off the Most active board, so
          winning one never helps you win the next.{" "}
          <a
            href={COMMUNITY_EXPLORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="dsc-inline-link"
          >
            See today's board ↗
          </a>
        </p>
      </section>
    </>
  );
}
